import { supabase } from './supabase'

export type EditableTable = 'units' | 'lessons' | 'contents' | 'exercises'

interface SaveFieldArgs {
  table: EditableTable
  id: string
  field: string
  oldValue: string | null
  newValue: string | null
  // Valor a escribir en la columna. Por defecto = newValue.
  // Útil para columnas no-string (ej. text[], jsonb): el history guarda
  // el JSON stringificado pero la DB recibe el valor real.
  dbValue?: unknown
  editedBy: string
}

export async function saveField({
  table,
  id,
  field,
  oldValue,
  newValue,
  dbValue,
  editedBy
}: SaveFieldArgs): Promise<{ error: Error | null }> {
  if (oldValue === newValue && dbValue === undefined) return { error: null }

  const historyRes = await (supabase.from('entity_edit_history') as any).insert({
    entity_table: table,
    entity_id: id,
    field_name: field,
    old_value: oldValue,
    new_value: newValue,
    edited_by: editedBy
  })

  if (historyRes.error) {
    return { error: new Error(`No se pudo guardar el historial: ${historyRes.error.message}`) }
  }

  const valueToWrite = dbValue !== undefined ? dbValue : newValue
  const updateRes = await (supabase.from(table) as any)
    .update({ [field]: valueToWrite })
    .eq('id', id)

  if (updateRes.error) {
    return { error: new Error(`No se pudo guardar el cambio: ${updateRes.error.message}`) }
  }

  return { error: null }
}

interface SaveArrayItemArgs {
  table: EditableTable
  id: string
  field: string
  currentArray: string[]
  index: number
  newItemValue: string
  editedBy: string
}

// Helper para editar un item de un array (ej. exercises.options[i])
export async function saveArrayItem({
  table,
  id,
  field,
  currentArray,
  index,
  newItemValue,
  editedBy
}: SaveArrayItemArgs): Promise<{ error: Error | null; newArray: string[] }> {
  const newArray = [...currentArray]
  newArray[index] = newItemValue
  const { error } = await saveField({
    table,
    id,
    field,
    oldValue: JSON.stringify(currentArray),
    newValue: JSON.stringify(newArray),
    dbValue: newArray,
    editedBy
  })
  return { error, newArray }
}
